import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { Shift } from 'app/models/shift.model';
import { ShiftService } from 'app/services/shift.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { ShiftContainerListComponent } from '../shift-container-list/shift-container-list.component';
import { ShiftComponent } from '../shift-form/shift.component';

@Component({
    selector: 'app-shift-list',
    templateUrl: './shift-list.component.html',
    styleUrls: ['./shift-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class ShiftListComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }

    private _dataSource: MatTableDataSource<Shift> = undefined;
    public get dataSource(): MatTableDataSource<Shift> {
        return this._dataSource;
    }

    private _displayedColumns = ['id', 'plate', 'startDate', 'endDate', 'status', 'complated', "setting"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    public companyId: number;
    public shiftList: Array<Shift>;

    constructor(
        private _shiftService: ShiftService,
        private _dialog: MatDialog,
        private _spinner: NgxSpinnerService,
        private _toastService: ToasterService,
    ) {
    }

    async ngOnInit() {

        this.companyId=  parseInt(localStorage.getItem("CompanyID"))
        await this.getShift()
    }

    public async getShift() {

        try {
            this._spinner.show('loading');
            this.shiftList = await this._shiftService.getShift(this.companyId)
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);

        }
        await this.updateTableDataSource();
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'plate': return  item.car.plate;
              default: return item[property];
         }
    }
    }

    private async updateTableDataSource(): Promise<void> {

        this._dataSource = new MatTableDataSource<Shift>(this.shiftList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;

    }

    add() {
        const dialog = this._dialog.open(ShiftComponent, {
            data: new Shift(),
            disableClose: false
        });
        dialog.componentInstance.operation = "create"
        dialog.componentInstance.added.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });
    }
    update(shift: Shift) {

        const dialog = this._dialog.open(ShiftComponent, {
            data: cloneDeep(shift),
            disableClose: false
        });
        dialog.componentInstance.shift = cloneDeep(shift);
        dialog.componentInstance.selectedCompany = cloneDeep(shift.companyId);
        dialog.componentInstance.shift.containers = [];
        dialog.componentInstance.operation = "update";
        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });

    }

    containerDetail(shift: Shift) {

        this._dialog.open(ShiftContainerListComponent, {
            data: shift.id,
            disableClose: false
        })
    }

    async deleteShift(shift: Shift) {
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen vardiyayı silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                await this._shiftService.delete(shift)
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })
            this.refresh();
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }

    }

    refresh() {
        this.getShift();
    }

}
